import React from 'react';
import { useTheme } from '../../theme';
import SectionLabel from '../shared/SectionLabel';

const stories = [
  {
    quote: 'We played Halo 3 together every night for two years. Lost touch when I switched schools. Found her here eleven years later.',
    user: 'kestrel_99',
    platform: 'Xbox',
    year: '2024',
  },
  {
    quote: "I didn't think anyone remembered that guild. He did.",
    user: 'marisol_v',
    platform: 'Discord',
    year: '2025',
  },
  {
    quote: "My old doubles partner from Rocket League. We're playing again.",
    user: 'ghostpilot',
    platform: 'Steam',
    year: '2025',
  },
];

export default function ReunionStories() {
  const { p, d, fonts } = useTheme();

  return (
    <section style={{
      padding: `${d.gap * 2.5}px ${d.pad}px`,
      borderBottom: `1px solid ${p.border}`,
    }}>
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <SectionLabel>§ 04 / reunions</SectionLabel>

        <h2 style={{
          fontFamily: fonts.serif, fontSize: 48, fontWeight: 400,
          letterSpacing: '-.03em', lineHeight: 1, margin: '0 0 6px',
          color: p.textHi,
        }}>
          They found each other.
        </h2>
        <p style={{
          fontFamily: fonts.serif, fontStyle: 'italic', fontSize: 15,
          color: p.textDim, margin: '0 0 40px',
        }}>
          Some of the people this index has reconnected.
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 0,
          border: `1px solid ${p.border}`,
        }}>
          {stories.map((s, i) => (
            <div key={i} style={{
              padding: '32px 28px',
              borderLeft: i > 0 ? `1px solid ${p.border}` : 'none',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}>
              <div style={{
                fontFamily: fonts.serif, fontStyle: 'italic', fontSize: 16,
                lineHeight: 1.55, color: p.text, marginBottom: 24,
              }}>
                "{s.quote}"
              </div>
              <div style={{
                fontFamily: fonts.mono, fontSize: 11, color: p.textDim,
                letterSpacing: '.06em',
              }}>
                {s.user} · {s.platform} · {s.year}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          section > div > div:last-of-type { grid-template-columns: 1fr !important; }
          section > div > div:last-of-type > div { border-left: none !important; border-top: 1px solid var(--border, #22222a); }
          section > div > div:last-of-type > div:first-child { border-top: none !important; }
        }
      `}</style>
    </section>
  );
}
